'use client';

import CheckIconSvg from '@/assets/svgs/check.svg';
import { TestContactList, TestContactPhone } from '@/containers/ContactLists/types';

interface ContactSelectionProps {
  testList: TestContactList | null;
  contactsSent: Record<string, boolean>;
  onSendMessage: (phone: string) => void;
  isSendingMessage: boolean;
  sendingMessageTo: Record<string, boolean>;
}

const ContactSelection = ({
  testList,
  contactsSent,
  onSendMessage,
  sendingMessageTo,
}: ContactSelectionProps) => {
  const contacts = testList?.test_contact_phones || [];

  const getDisplayName = (contact: TestContactPhone) => {
    const firstName = contact.first_name || '';
    const lastName = contact.last_name || '';

    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    } else if (firstName) {
      return firstName;
    } else if (lastName) {
      return lastName;
    } else {
      return 'Name not available';
    }
  };

  const formatPhone = (phone: string) => {
    if (phone.length === 10) {
      return `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`;
    }
    return phone;
  };

  const handleSendMessage = (contact: TestContactPhone) => {
    const phone = contact.lead_phone;
    onSendMessage(phone);
  };

  return (
    <div className="rounded-xl border border-gray-200 p-1">
      <h3 className="rounded-lg bg-neutral-100 p-4 text-base font-medium">
        Send a test message to selected contacts
      </h3>

      {!testList ? (
        <div className="rounded-md border py-4 text-center">
          Please select a test list first.
        </div>
      ) : contacts.length > 0 ? (
        <div className="flex flex-col">
          {contacts.map((contact) => {
            const phone = contact.lead_phone;
            const isSent = contactsSent[phone];
            return (
              <div
                key={`${contact.sublist_id}-${phone}`}
                className={`mt-1 flex items-center justify-between rounded-lg p-3 ${isSent ? 'bg-neutral-100' : ''}`}>
                <div>
                  <div className="font-medium">{getDisplayName(contact)}</div>
                  <div className="text-sm text-gray-500">{formatPhone(phone)}</div>
                </div>
                {isSent ? (
                  <div className="flex items-center font-medium text-blue-600">
                    Sent <CheckIconSvg className="ml-2 h-4 w-4" />
                  </div>
                ) : (
                  <button
                    className="btn bg-white"
                    onClick={() => handleSendMessage(contact)}
                    disabled={sendingMessageTo[phone]}>
                    {sendingMessageTo[phone] ? (
                      <span className="loading loading-spinner loading-sm"></span>
                    ) : (
                      'Send test message'
                    )}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="rounded-md border py-4 text-center">
          No contacts found in this test list.
        </div>
      )}
    </div>
  );
};

export default ContactSelection;
